// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3mcBV","header":"ClearentDisclaimer_header__1YXet","inner":"ClearentDisclaimer_inner__1LQVo"};